import { useEffect, useRef } from 'react';
import { browserHistory } from '@client/router/compat';

export const useBrowserHistorySync = (onPathChange: () => void): void => {
  const onPathChangeRef = useRef(onPathChange);

  useEffect(() => {
    onPathChangeRef.current = onPathChange;
  }, [onPathChange]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handlePopState = (): void => {
      onPathChangeRef.current();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    const unlisten = browserHistory.listen(() => {
      onPathChangeRef.current();
    });

    return () => {
      unlisten();
    };
  }, []);
};
